// extracted by mini-css-extract-plugin
module.exports = {"disable-scroll":"creditdetails_disable-scroll__16Tfu","credit-details":"creditdetails_credit-details__1ne8s"};